import { HttpRequest, HttpHandler, HttpEvent, HttpInterceptor, HttpErrorResponse, HttpResponse } from '@angular/common/http';
import { Injectable, Injector } from '@angular/core';
import { Router } from '@angular/router';
import { Observable, throwError } from 'rxjs';
import { catchError, tap } from 'rxjs/operators';

import { SessionService } from './session.service';
import { LOCALSTORAGE_STATE } from '../custom-lib/oauth2-auth-code-PKCE';

@Injectable()
export class TokenInterceptorService implements HttpInterceptor {
    constructor(private _injector: Injector) {}

    intercept(request: HttpRequest<any>, next: HttpHandler): Observable<HttpEvent<any>> {
        const sessionService = this._injector.get(SessionService);

        let accessToken = null;
        let authInfo = JSON.parse(localStorage.getItem(LOCALSTORAGE_STATE));
        if (localStorage.hasOwnProperty(LOCALSTORAGE_STATE) && authInfo.accessToken) {
            accessToken = authInfo.accessToken.value;
        }
        if (this.isInvalidToken(accessToken)) {
            this.logoutV2(sessionService, 'You are not logged in');
            return throwError(() => new Error('Access token not found'));
        }
        return next.handle(this.customRequest(request, accessToken)).pipe(
            tap({
                next: _val => (event: HttpEvent<any>) => {
                    if (event instanceof HttpResponse) {
                        return event;
                    }
                },
                error: _error => {
                    if (_error instanceof HttpErrorResponse) {
                        if (_error.status === 401) {
                            let refreshToken = authInfo.refreshToken.value;
                            if (this.isInvalidToken(refreshToken)) {
                                this.logoutV2(sessionService, 'You are not logged in');
                                return throwError(() => new Error('Refresh token not found'));
                            }
                            return sessionService.renewToken$().subscribe({
                                next: _response => {
                                    authInfo = JSON.parse(localStorage.getItem(LOCALSTORAGE_STATE));
                                    let accessToken = authInfo.accessToken.value;
                                    if (this.isInvalidToken(accessToken)) {
                                        this.logoutV2(sessionService, 'You are not logged in');
                                        return throwError(() => new Error('Access token not found'));
                                    } else {
                                        return (
                                            next.handle(this.customRequest(request, accessToken)).subscribe((evn: HttpEvent<any>) => {
                                                if (evn instanceof HttpResponse) {
                                                    return evn;
                                                }
                                            }),
                                            catchError((er: any) => {
                                                er.loggedIn = true;
                                                return throwError(() => new Error(er));
                                            })
                                        );
                                    }
                                },
                                error: _err => {
                                    this.logoutV2(sessionService, 'You are not logged in');
                                    return throwError(() => new Error('Access token not found'));
                                },
                                complete: () => {}
                            });
                        }
                    }
                    return throwError(() => new Error(_error));
                },
                complete: () => {}
            })
        );
    }

    isInvalidToken(token: string): boolean {
        return typeof token === 'undefined' || token === null || token.toString().length === 0;
    }

    customRequest(request: HttpRequest<any>, accessToken: string): HttpRequest<any> {
        let req = request.clone({
            setHeaders: {
                Authorization: 'Bearer {0}'.replace('{0}', accessToken)
            }
        });
        return req;
    }

    logoutV2(sessionService: SessionService, logoutMessage: string, hasSessionExpired: boolean = false): void {
        const router = this._injector.get(Router);
        sessionService.redirectUrl = router.url;
        sessionService.logoutMessage = logoutMessage;
        sessionService.hasSessionExpired = hasSessionExpired;
        sessionService.logoutV2();
    }
}
